import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET BRANCH DCB REPORT START *********************** */
export const branchDCBReportListGet = (listData: any) => {
	const data = {
		GetBranchDCBReportToken: listData,
	};
	const url = `${API_URL}getBranchDCBReport`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH DCB REPORT START ************************/
